// Fontes self-hosted (W0.1) — variable fonts embutidas no bundle (sem Google Fonts CDN).
import '@fontsource-variable/inter/index.css'
import '@fontsource-variable/outfit/index.css'
import '@fontsource-variable/jetbrains-mono/index.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './styles/wireframe.css'
import App from './App'
import { setupPwaAutoUpdate } from './lib/pwa'

// PWA: registra o SW com checagem ATIVA de update (poll + foco) pra o app instalado
// atualizar sozinho após novo deploy — sem isso só checava no load (Breno 2026-06-23).
setupPwaAutoUpdate()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
